var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCreditSuisse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167.409,
    height: 21.23,
    viewBox: "0 0 167.409 21.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1812",
    "data-name": "Rectangle 1812",
    width: 167.409,
    height: 21.23,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_credit_suisse",
    "data-name": "logo credit suisse",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15178",
    "data-name": "Path 15178",
    d: "M132.325,14.026h-10.8v2.4l.326-.03v-.029a1.664,1.664,0,0,1,1.509-1.024h2.4V27.721h2.367V15.372h2.455a1.391,1.391,0,0,1,1.45.849v.058h.355l-.029-2.194h-.03Z",
    transform: "translate(-63.8 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15179",
    "data-name": "Path 15179",
    d: "M30.7,14.026h-.059v.322l.029.029a1.567,1.567,0,0,1,.414,1.229V27.721H33.4V21.488h1.036c.917.059,1.272.644,1.716,1.4l.059.088.3.468c.5.819,1.183,1.931,1.864,2.985a2.77,2.77,0,0,0,1.923,1.288,7.32,7.32,0,0,0,2.13-.059l.5-.117.207-.059-.71-.2a2.862,2.862,0,0,1-1.331-.965,29.592,29.592,0,0,1-1.893-2.78l-.888-1.4-.029-.03a3.662,3.662,0,0,0-1.331-1.258,3.535,3.535,0,0,0,2.574-3.336,3.066,3.066,0,0,0-.976-2.253,5.725,5.725,0,0,0-4.054-1.229Zm3.964,1.229A2.275,2.275,0,0,1,37.1,17.537a2.566,2.566,0,0,1-2.781,2.692s-.828-.029-.917-.029V15.255c.266,0,.71-.029,1.272,0",
    transform: "translate(-16.088 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15180",
    "data-name": "Path 15180",
    d: "M80.534,13.993h-.059l.03.351h.029c.207.087.385.585.385.995V27.658h3.965a8.515,8.515,0,0,0,6.273-2.311,6.614,6.614,0,0,0,.532-8.72c-1.361-1.756-3.521-2.663-6.45-2.663Zm2.752,1.317h1.242a14.426,14.426,0,0,1,1.746.117,4.858,4.858,0,0,1,4.32,5.179,6.427,6.427,0,0,1-1.183,3.95,5.316,5.316,0,0,1-4.439,1.814c-.474,0-1.065,0-1.716-.03.03-.087.03-10.915.03-11.032",
    transform: "translate(-42.248 -7.404)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15181",
    "data-name": "Path 15181",
    d: "M114.092,14.026H111.37v.322l.03.029c.237.117.414.556.414,1.142v12.2h2.308V14.055Z",
    transform: "translate(-58.468 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15182",
    "data-name": "Path 15182",
    d: "M65.711,14.026H57.929l.03.322h.029a1.511,1.511,0,0,1,.444,1.229V27.691h7.752l.562-2.429-.325-.117-.089.147c-.651.995-1.3,1.112-3.55,1.112a19.649,19.649,0,0,1-2.072-.088V20.727h3.935V19.5H60.71V15.255c.119,0,3.2.029,3.2.029a1.825,1.825,0,0,1,1.568,1.083v.059H65.8Z",
    transform: "translate(-30.412 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15183",
    "data-name": "Path 15183",
    d: "M207.9,14.026h-2.722l.029.322h.03a1.368,1.368,0,0,1,.414,1.171v12.2h2.309V14.055Z",
    transform: "translate(-107.713 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15184",
    "data-name": "Path 15184",
    d: "M270.356,13.993H262.6l.03.351h.029a1.439,1.439,0,0,1,.444,1.2V27.658h7.752l.562-2.429-.355-.117-.089.147c-.651,1-1.3,1.112-3.521,1.112a19.633,19.633,0,0,1-2.071-.088V20.694h3.935V19.465h-3.935V15.222c.118,0,3.195.029,3.195.029.888,0,1.539.644,1.539,1.083v.059l.355-.03-.059-2.4Z",
    transform: "translate(-137.864 -7.404)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15185",
    "data-name": "Path 15185",
    d: "M218.619,17.346c-.029,1.9,1.124,2.838,3.018,3.775l.71.351c1.48.731,2.456,1.2,2.456,2.575a2.55,2.55,0,0,1-.68,1.7,2.5,2.5,0,0,1-1.835.644,3.427,3.427,0,0,1-3.313-2.722l-.059-.176-.473.088.118,2.868.119.059a7.62,7.62,0,0,0,3.728,1.141,4.916,4.916,0,0,0,3.4-1.346,3.789,3.789,0,0,0,1.183-2.751c0-2.4-1.686-3.248-3.461-4.184l-.325-.176c-1.923-.936-2.574-1.375-2.574-2.429a1.884,1.884,0,0,1,2.1-1.814A2.862,2.862,0,0,1,225.572,17l.059.2.474-.059-.178-2.517-.089-.058a5.626,5.626,0,0,0-2.929-.79c-2.071-.029-4.26,1.229-4.29,3.57",
    transform: "translate(-114.679 -7.304)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15186",
    "data-name": "Path 15186",
    d: "M154.59,17.377c-.03,1.9,1.124,2.838,3.018,3.775l.71.351c1.479.731,2.456,1.2,2.456,2.575a2.549,2.549,0,0,1-.681,1.7,2.5,2.5,0,0,1-1.835.644,3.427,3.427,0,0,1-3.313-2.722l-.059-.176-.474.088.118,2.868.118.059a7.624,7.624,0,0,0,3.728,1.141,4.918,4.918,0,0,0,3.4-1.346,3.789,3.789,0,0,0,1.183-2.751c0-2.4-1.686-3.248-3.461-4.184l-.325-.176c-1.923-.936-2.575-1.375-2.575-2.429a1.885,1.885,0,0,1,2.1-1.814,2.862,2.862,0,0,1,2.84,2.049l.059.2.473-.059-.148-2.487-.089-.059a5.626,5.626,0,0,0-2.929-.79c-2.071-.058-4.29,1.2-4.32,3.541",
    transform: "translate(-81.064 -7.335)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15187",
    "data-name": "Path 15187",
    d: "M240.485,17.313c-.029,1.9,1.124,2.838,3.018,3.775l.71.351c1.48.731,2.456,1.2,2.456,2.575a2.55,2.55,0,0,1-.68,1.7,2.5,2.5,0,0,1-1.835.644,3.427,3.427,0,0,1-3.314-2.722l-.059-.176-.473.088.118,2.868.118.059a7.62,7.62,0,0,0,3.728,1.141,4.916,4.916,0,0,0,3.4-1.346,3.789,3.789,0,0,0,1.183-2.751c0-2.4-1.686-3.248-3.461-4.184l-.325-.176c-1.923-.936-2.574-1.375-2.574-2.429a1.837,1.837,0,0,1,.562-1.287,2.244,2.244,0,0,1,1.539-.556,2.863,2.863,0,0,1,2.841,2.048l.059.176.474-.059-.148-2.487-.089-.059a5.627,5.627,0,0,0-2.929-.79c-2.071,0-4.29,1.258-4.32,3.6",
    transform: "translate(-126.158 -7.271)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15188",
    "data-name": "Path 15188",
    d: "M187.082,13.96h-1.834l.029.322h.029c.089.059.385.264.385,1.112v7.754c0,1.493-.562,3.307-3.225,3.307-2.515,0-3.047-1.493-3.047-3.717V13.931h-2.9l.029.293h.03a1.333,1.333,0,0,1,.5,1.2v7.287c0,4.536,3.018,5.033,5.3,5.033,1.124,0,4.734-.322,4.734-4.594V13.9Z",
    transform: "translate(-92.67 -7.37)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15189",
    "data-name": "Path 15189",
    d: "M1.923,15.654l.029.029-.029-.029A7.258,7.258,0,0,0,0,20.541a6.842,6.842,0,0,0,2.249,5.15,7.681,7.681,0,0,0,5.208,1.931,9.788,9.788,0,0,0,5.03-1.376l.088-.058.237-2.838-.385-.03-.059.117a4.088,4.088,0,0,1-4.557,2.634c-3.817,0-5.119-2.78-5.119-5.794,0-2.9,1.3-5.384,5.148-5.384a4.161,4.161,0,0,1,4.439,2.6l.059.147.355-.117-.237-2.955-.088-.029a11.47,11.47,0,0,0-4.7-1.141,7.556,7.556,0,0,0-5.74,2.253",
    transform: "translate(0 -7.105)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15190",
    "data-name": "Path 15190",
    d: "M311.689,16.381a24.779,24.779,0,0,0-7.4-.293.166.166,0,0,1-.207-.176,29.773,29.773,0,0,0-.562-5.823c0-.058-.03-.088-.089-.117a113.621,113.621,0,0,0-15.267-8.925.182.182,0,0,0-.207.293c7.249,6.584,9.794,17.792,10.119,19.284a.222.222,0,0,0,.207.146c8.136-1.551,16.3.381,18.581,1a.178.178,0,0,0,.178-.293c-1.687-1.785-3.462-3.453-5.266-5.033,0-.03-.03-.059-.089-.059",
    transform: "translate(-151.146 -0.545)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15191",
    "data-name": "Path 15191",
    d: "M331.329,16.978C324.79,8.316,315.5,1.937,312.571.035c-.178-.117-.355.087-.237.263A22.122,22.122,0,0,1,316.3,9.4a.152.152,0,0,0,.059.117c2.692,1.873,5.444,3.98,8.166,6.291a.11.11,0,0,0,.089.029c2.84.468,5.444,1.112,6.509,1.4a.174.174,0,0,0,.207-.264",
    transform: "translate(-163.951 0)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15192",
    "data-name": "Path 15192",
    d: "M132.325,14.026h-10.8v2.4l.326-.03v-.029a1.664,1.664,0,0,1,1.509-1.024h2.4V27.721h2.367V15.372h2.455a1.391,1.391,0,0,1,1.45.849v.058h.355l-.029-2.194h-.03Z",
    transform: "translate(-63.8 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15193",
    "data-name": "Path 15193",
    d: "M30.7,14.026h-.059v.322l.029.029a1.567,1.567,0,0,1,.414,1.229V27.721H33.4V21.488h1.036c.917.059,1.272.644,1.716,1.4l.059.088.3.468c.5.819,1.183,1.931,1.864,2.985a2.77,2.77,0,0,0,1.923,1.288,7.32,7.32,0,0,0,2.13-.059l.5-.117.207-.059-.71-.2a2.862,2.862,0,0,1-1.331-.965,29.592,29.592,0,0,1-1.893-2.78l-.888-1.4-.029-.03a3.662,3.662,0,0,0-1.331-1.258,3.535,3.535,0,0,0,2.574-3.336,3.066,3.066,0,0,0-.976-2.253,5.725,5.725,0,0,0-4.054-1.229Zm3.964,1.229A2.275,2.275,0,0,1,37.1,17.537a2.566,2.566,0,0,1-2.781,2.692s-.828-.029-.917-.029V15.255c.266,0,.71-.029,1.272,0",
    transform: "translate(-16.088 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15194",
    "data-name": "Path 15194",
    d: "M80.534,13.993h-.059l.03.351h.029c.207.087.385.585.385.995V27.658h3.965a8.515,8.515,0,0,0,6.273-2.311,6.614,6.614,0,0,0,.532-8.72c-1.361-1.756-3.521-2.663-6.45-2.663Zm2.752,1.317h1.242a14.426,14.426,0,0,1,1.746.117,4.858,4.858,0,0,1,4.32,5.179,6.427,6.427,0,0,1-1.183,3.95,5.316,5.316,0,0,1-4.439,1.814c-.474,0-1.065,0-1.716-.03.03-.087.03-10.915.03-11.032",
    transform: "translate(-42.248 -7.404)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15195",
    "data-name": "Path 15195",
    d: "M114.092,14.026H111.37v.322l.03.029c.237.117.414.556.414,1.142v12.2h2.308V14.055Z",
    transform: "translate(-58.468 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15196",
    "data-name": "Path 15196",
    d: "M65.711,14.026H57.929l.03.322h.029a1.511,1.511,0,0,1,.444,1.229V27.691h7.752l.562-2.429-.325-.117-.089.147c-.651.995-1.3,1.112-3.55,1.112a19.649,19.649,0,0,1-2.072-.088V20.727h3.935V19.5H60.71V15.255c.119,0,3.2.029,3.2.029a1.825,1.825,0,0,1,1.568,1.083v.059H65.8Z",
    transform: "translate(-30.412 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15197",
    "data-name": "Path 15197",
    d: "M207.9,14.026h-2.722l.029.322h.03a1.368,1.368,0,0,1,.414,1.171v12.2h2.309V14.055Z",
    transform: "translate(-107.713 -7.437)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15198",
    "data-name": "Path 15198",
    d: "M270.356,13.993H262.6l.03.351h.029a1.439,1.439,0,0,1,.444,1.2V27.658h7.752l.562-2.429-.355-.117-.089.147c-.651,1-1.3,1.112-3.521,1.112a19.633,19.633,0,0,1-2.071-.088V20.694h3.935V19.465h-3.935V15.222c.118,0,3.195.029,3.195.029.888,0,1.539.644,1.539,1.083v.059l.355-.03-.059-2.4Z",
    transform: "translate(-137.864 -7.404)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15199",
    "data-name": "Path 15199",
    d: "M218.619,17.346c-.029,1.9,1.124,2.838,3.018,3.775l.71.351c1.48.731,2.456,1.2,2.456,2.575a2.55,2.55,0,0,1-.68,1.7,2.5,2.5,0,0,1-1.835.644,3.427,3.427,0,0,1-3.313-2.722l-.059-.176-.473.088.118,2.868.119.059a7.62,7.62,0,0,0,3.728,1.141,4.916,4.916,0,0,0,3.4-1.346,3.789,3.789,0,0,0,1.183-2.751c0-2.4-1.686-3.248-3.461-4.184l-.325-.176c-1.923-.936-2.574-1.375-2.574-2.429a1.884,1.884,0,0,1,2.1-1.814A2.862,2.862,0,0,1,225.572,17l.059.2.474-.059-.178-2.517-.089-.058a5.626,5.626,0,0,0-2.929-.79c-2.071-.029-4.26,1.229-4.29,3.57",
    transform: "translate(-114.679 -7.304)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15200",
    "data-name": "Path 15200",
    d: "M154.59,17.377c-.03,1.9,1.124,2.838,3.018,3.775l.71.351c1.479.731,2.456,1.2,2.456,2.575a2.549,2.549,0,0,1-.681,1.7,2.5,2.5,0,0,1-1.835.644,3.427,3.427,0,0,1-3.313-2.722l-.059-.176-.474.088.118,2.868.118.059a7.624,7.624,0,0,0,3.728,1.141,4.918,4.918,0,0,0,3.4-1.346,3.789,3.789,0,0,0,1.183-2.751c0-2.4-1.686-3.248-3.461-4.184l-.325-.176c-1.923-.936-2.575-1.375-2.575-2.429a1.885,1.885,0,0,1,2.1-1.814,2.862,2.862,0,0,1,2.84,2.049l.059.2.473-.059-.148-2.487-.089-.059a5.626,5.626,0,0,0-2.929-.79c-2.071-.058-4.29,1.2-4.32,3.541",
    transform: "translate(-81.064 -7.335)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15201",
    "data-name": "Path 15201",
    d: "M240.485,17.313c-.029,1.9,1.124,2.838,3.018,3.775l.71.351c1.48.731,2.456,1.2,2.456,2.575a2.55,2.55,0,0,1-.68,1.7,2.5,2.5,0,0,1-1.835.644,3.427,3.427,0,0,1-3.314-2.722l-.059-.176-.473.088.118,2.868.118.059a7.62,7.62,0,0,0,3.728,1.141,4.916,4.916,0,0,0,3.4-1.346,3.789,3.789,0,0,0,1.183-2.751c0-2.4-1.686-3.248-3.461-4.184l-.325-.176c-1.923-.936-2.574-1.375-2.574-2.429a1.837,1.837,0,0,1,.562-1.287,2.244,2.244,0,0,1,1.539-.556,2.863,2.863,0,0,1,2.841,2.048l.059.176.474-.059-.148-2.487-.089-.059a5.627,5.627,0,0,0-2.929-.79c-2.071,0-4.29,1.258-4.32,3.6",
    transform: "translate(-126.158 -7.271)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15202",
    "data-name": "Path 15202",
    d: "M187.082,13.96h-1.834l.029.322h.029c.089.059.385.264.385,1.112v7.754c0,1.493-.562,3.307-3.225,3.307-2.515,0-3.047-1.493-3.047-3.717V13.931h-2.9l.029.293h.03a1.333,1.333,0,0,1,.5,1.2v7.287c0,4.536,3.018,5.033,5.3,5.033,1.124,0,4.734-.322,4.734-4.594V13.9Z",
    transform: "translate(-92.67 -7.37)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15203",
    "data-name": "Path 15203",
    d: "M1.923,15.654l.029.029-.029-.029A7.258,7.258,0,0,0,0,20.541a6.842,6.842,0,0,0,2.249,5.15,7.681,7.681,0,0,0,5.208,1.931,9.788,9.788,0,0,0,5.03-1.376l.088-.058.237-2.838-.385-.03-.059.117a4.088,4.088,0,0,1-4.557,2.634c-3.817,0-5.119-2.78-5.119-5.794,0-2.9,1.3-5.384,5.148-5.384a4.161,4.161,0,0,1,4.439,2.6l.059.147.355-.117-.237-2.955-.088-.029a11.47,11.47,0,0,0-4.7-1.141,7.556,7.556,0,0,0-5.74,2.253",
    transform: "translate(0 -7.105)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15204",
    "data-name": "Path 15204",
    d: "M311.689,16.381a24.779,24.779,0,0,0-7.4-.293.166.166,0,0,1-.207-.176,29.773,29.773,0,0,0-.562-5.823c0-.058-.03-.088-.089-.117a113.621,113.621,0,0,0-15.267-8.925.182.182,0,0,0-.207.293c7.249,6.584,9.794,17.792,10.119,19.284a.222.222,0,0,0,.207.146c8.136-1.551,16.3.381,18.581,1a.178.178,0,0,0,.178-.293c-1.687-1.785-3.462-3.453-5.266-5.033,0-.03-.03-.059-.089-.059",
    transform: "translate(-151.146 -0.545)",
    fill: "#183964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15205",
    "data-name": "Path 15205",
    d: "M331.329,16.978C324.79,8.316,315.5,1.937,312.571.035c-.178-.117-.355.087-.237.263A22.122,22.122,0,0,1,316.3,9.4a.152.152,0,0,0,.059.117c2.692,1.873,5.444,3.98,8.166,6.291a.11.11,0,0,0,.089.029c2.84.468,5.444,1.112,6.509,1.4a.174.174,0,0,0,.207-.264",
    transform: "translate(-163.951 0)",
    fill: "#183964"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCreditSuisse);
export default __webpack_public_path__ + "static/media/logo_credit_suisse.2a336a3df0a4ecf84ed3cffea4e29a4c.svg";
export { ForwardRef as ReactComponent };